import QuotePreviewImage from '@/assets/CNC-rfq/quote-preview.png';
import Text from '@/components/Text';

const demoVideoUrl =
  'https://mpstorage4.blob.core.windows.net/public-files/assets/MindPal-Chris-Demo-CNC-landing-solutions.mp4';

const CncRfqQuotePreview = () => {
  return (
    <div className="flex w-full flex-col items-center gap-11">
      <div className="flex flex-col items-center gap-5 text-center">
        <Text
          variant="display-4"
          className="max-w-3xl text-center text-jb-neutral-900"
        >
          See the quote before you commit
        </Text>
        <Text className="max-w-xl text-center text-jb-neutral-800">
          The moment a file lands, the engine returns an itemized, editable
          estimate: unit price, lead time and manufacturability flags. All in
          about 30 seconds.
        </Text>
      </div>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption -- no transcript exists for this demo clip */}
      <video
        src={demoVideoUrl}
        poster={QuotePreviewImage.src}
        controls
        className="aspect-video w-full max-w-4xl rounded-2xl"
      />
    </div>
  );
};

export default CncRfqQuotePreview;
